import { Box, CircularProgress } from '@mui/material';
import { FC } from 'react';

interface ILoaderProps {
    noBackground?: boolean;
}

export const Loader: FC<ILoaderProps> = ({ noBackground }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: noBackground ? '' : 'rgba(255, 255, 255, 0.8)',
                zIndex: 9999,
            }}
        >
            <CircularProgress />
        </Box>
    );
};